const loginHelpTemplate = `<pwr-login-help accu="accu">
   </pwr-login-help> `;

export default loginHelpTemplate;
